const translations = {
    actionsLabel: 'Certification actions',
    addCertification: 'Add Certification',
    certificationCategories: 'Categories',
    certificationNumber: 'Certification Number',
    delete: 'Delete',
    deleteConfirmCancel: 'Keep Certification',
    deleteConfirmLabel: 'Delete Certification',
    deleteConfirmMessage: 'This applicator pesticide certification will be permanently removed.',
    deleteConfirmTitle: 'Delete this certification?',
    deleteError: 'Applicator pesticide certification could not be deleted.',
    deleteSuccess: 'Applicator pesticide certification deleted.',
    edit: 'Edit',
    emptyDescription: 'Add an applicator pesticide certification to see it listed here.',
    emptyHeading: 'No applicator pesticide certifications yet',
    expirationDate: 'Expiration Date',
    expired: 'Expired',
    issuedDate: 'Issued Date',
    loadError: 'Applicator pesticide certifications could not be loaded.',
    loadMore: 'Load more',
    state: 'State',
    tableLabel: 'Applicator pesticide certifications',
    title: 'Applicator Pesticide Certifications'
};

export default translations;
